import React, { useState } from "react";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../../context/actions/user";
import Head from "../Head";
import { forgotPasswordSchema, forgotPasswordInit } from "./schema";
import TextInput from "../../../components/common/FormsInput/FormInput";
import { Formik, Form } from "formik";

toast.configure();
const ForgotPassword = () => {
  localStorage.removeItem("_expiredTime");
  const dispatch = useDispatch();

  const [payload, setPlayload] = useState({
    ...forgotPasswordInit
  });

  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);



  const submitForm = (data) => {
    setDisabled(true)
    dispatch(
      forgotPassword(data, (result) => {
        setDisabled(false);
      })
    );
  };

  return (
    <div className={`login-blc m-auto signup-box`}>
      <Head heading="Forgot Password" />
      <Formik
        initialValues={payload}
        enableReinitialize
        validationSchema={forgotPasswordSchema}
        onSubmit={submitForm}
      >
        {(formik) => (<Form >
          <TextInput
                    name="email"
                    placeholder="Enter your email"
                    value={formik?.values?.email}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Email Address"
                  />
          <div className="btn-cell d-flex">
            <Button
              disabled={disabled}
              className="flex-fill"
              color="primary"
              type="submit"
            >
              Submit
          </Button>
          </div>
        </Form>)}
      </Formik>
      Back to login ? <Link to="/login">Login</Link>
    </div>
  );
};

export default ForgotPassword;